import { render, staticRenderFns } from "./kswitch.vue?vue&type=template&id=1e10e5a3&scoped=true"
import script from "./kswitch.vue?vue&type=script&lang=js"
export * from "./kswitch.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1e10e5a3",
  null
  
)

export default component.exports